import { ProjectDashboardComponent } from '@modules/projects/modules/project-dashboard/project-dashboard.component';
import { CustomRoutes } from '@shared/consts/routes/custom-routes.const';
import { TaskType } from '@shared/enums/task-type.enum';

export const ProjectDashboardRoutes: CustomRoutes = [
  {
    path: ':projectId',
    component: ProjectDashboardComponent,
    name: 'project-dashboard',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'summary'
      },
      {
        path: 'summary',
        name: 'project-dashboard-summary',
        data: { metaTitle: 'Projects.summary' },
        loadComponent: () =>
          import('@modules/projects/modules/project-summary-v2/project-summary.component').then(
            (x) => x.ProjectSummaryComponent
          )
      },
      {
        path: 'logbook',
        name: 'project-dashboard-logbook',
        data: { metaTitle: 'ProjectsDashboard.logbookPage.title' },
        loadComponent: () =>
          import('@modules/projects/modules/project-logbook/project-logbook.component').then(
            (x) => x.ProjectLogbookComponent
          )
      },
      {
        path: 'site-diary',
        name: 'project-dashboard-site-diary',
        data: { metaTitle: 'ProjectsDashboard.siteDiaryPage.title' },
        loadComponent: () =>
          import('@modules/projects/modules/project-site-diary/project-site-diary.component').then(
            (x) => x.ProjectSiteDiaryComponent
          )
      },
      {
        path: 'site-diary/:diaryId',
        name: 'project-dashboard-site-diary-detail',
        data: { metaTitle: 'Projects.siteDiaryDetail' },
        loadComponent: () =>
          import('@modules/projects/modules/project-site-diary-detail/project-site-diary-detail.component').then(
            (x) => x.ProjectSiteDiaryDetailComponent
          )
      },
      {
        path: 'stage-tasks/:stage',
        name: 'project-dashboard-stage-tasks',
        data: { metaTitle: 'Projects.tasks', type: TaskType.TYPE_TASK, notRestorationPosition: true },
        loadComponent: () =>
          import('@modules/projects/modules/project-dashboard/pages/project-stage-tasks/project-stage-tasks.component').then(
            (x) => x.ProjectStageTasksComponent
          )
      },
      {
        path: 'calendar',
        name: 'project-dashboard-calendar',
        data: {
          metaTitle: 'Projects.calendar',
          actionButtonText: 'Projects.newEvent',
          actionButtonIcon: './assets/img/ic-plus-add.svg'
        },
        canActivate: [],
        loadChildren: () =>
          import(`@project-modules/project-calendar/project-calendar.module`).then(
            (m) => m.ProjectCalendarModule
          )
      },
      {
        path: 'tasks',
        name: 'project-dashboard-tasks',
        data: {
          metaTitle: 'Projects.tasks',
          type: TaskType.TYPE_TASK,
          notRestorationPosition: true,
          actionButtonText: 'Projects.new.' + TaskType.TYPE_TASK,
          actionButtonIcon: './assets/img/ic-plus-add.svg'
        },
        canActivate: [],
        loadComponent: () =>
          import(`@project-modules/project-tasks/pages/project-tasks/project-tasks.component`).then(
            (m) => m.ProjectTasksComponent
          )
      },
      {
        path: 'orders',
        name: 'project-dashboard-orders',
        data: {
          metaTitle: 'Projects.orders',
          type: TaskType.TYPE_ORDER,
          notRestorationPosition: true,
          actionButtonText: 'Projects.new.' + TaskType.TYPE_ORDER,
          actionButtonIcon: './assets/img/ic-plus-add.svg'
        },
        canActivate: [],
        loadComponent: () =>
          import(`@project-modules/project-tasks/pages/project-tasks/project-tasks.component`).then(
            (m) => m.ProjectTasksComponent
          )
      },
      {
        path: 'corrections',
        name: 'project-dashboard-corrections',
        data: {
          metaTitle: 'Projects.corrections',
          type: TaskType.TYPE_CORRECTION,
          notRestorationPosition: true,
          actionButtonText: 'Projects.new.' + TaskType.TYPE_CORRECTION,
          actionButtonIcon: './assets/img/ic-plus-add.svg'
        },
        canActivate: [],
        loadComponent: () =>
          import(`@project-modules/project-tasks/pages/project-tasks/project-tasks.component`).then(
            (m) => m.ProjectTasksComponent
          )
      },
      {
        path: 'team',
        name: 'project-dashboard-team',
        data: {
          metaTitle: 'Projects.team',
          notRestorationPosition: false,
          actionButtonText: 'ProjectTeam.addNewTeamMember',
          actionButtonIcon: './assets/img/ic_plus_contact_white.svg'
        },
        canActivate: [],
        loadChildren: () =>
          import(`@project-modules/project-team/project-team.module`).then((m) => m.ProjectTeamModule)
      },
      {
        path: 'contacts',
        name: 'project-dashboard-contacts',
        data: {
          metaTitle: 'Projects.contacts',
          notRestorationPosition: false,
          actionButtonText: 'ProjectContacts.addNewContact',
          actionButtonIcon: './assets/img/ic_plus_contact_white.svg'
        },
        canActivate: [],
        loadChildren: () =>
          import(`@project-modules/project-contacts/project-contacts.module`).then(
            (m) => m.ProjectContactsModule
          )
      },
      {
        path: 'configurator',
        name: 'project-dashboard-configurator',
        data: {
          metaTitle: 'Projects.projectConfigurator',
          notRestorationPosition: true
        },
        canActivate: [],
        loadChildren: () =>
          import(`@project-modules/projects-configurator/projects-configurator.module`).then(
            (m) => m.ProjectsConfiguratorModule
          )
      },
      {
        path: 'configurator-v2',
        name: 'project-dashboard-configurator-v2',
        data: {
          metaTitle: 'Projects.projectConfigurator',
          notRestorationPosition: true
        },
        canActivate: [],
        loadChildren: () =>
          import(`@project-modules/projects-configurator-v2/projects-configurator-v2.module`).then(
            (m) => m.ProjectsConfiguratorV2Module
          )
      },
      {
        path: 'changes',
        name: 'project-dashboard-changes',
        data: {
          metaTitle: 'Projects.changes',
          notRestorationPosition: false,
          actionButtonText: 'ProjectChanges.newChange',
          actionButtonIcon: './assets/img/ic-plus-add.svg'
        },
        canActivate: [],
        loadChildren: () =>
          import(`@project-modules/project-changes/project-changes.module`).then(
            (m) => m.ProjectChangesModule
          )
      }
    ]
  }
];
